export const getCdnUrl = () => import.meta.env.VITE_CDN_URL || "https://cdn.region.game/";
